import { connect } from 'react-redux';
import { unhideDeviation, blockDeviationAuthor, unblockDeviationAuthor } from '../../Moderation/redux/actions';
import { getHighestPriorityBlockReasonForDeviation } from '../../Moderation/redux/selectors';
import { getIsLoggedIn, isUserOlderThan18 } from '../../publicSession/selectors';
import { toggleMature } from '../../publicSession/actions';
import { pushUserSettingsModal } from '../../Modals/redux/actionCreators';
const mapStateToProps = (state, { deviation  })=>({
        isLoggedIn: getIsLoggedIn(state),
        isUserOlderThan18: isUserOlderThan18(state),
        blockReason: getHighestPriorityBlockReasonForDeviation(state, deviation)
    });
const mapDispatchToProps = {
    unhideDeviation,
    blockDeviant: blockDeviationAuthor,
    unblockDeviant: unblockDeviationAuthor,
    disableMatureFilter: ()=>toggleMature(false),
    pushUserSettingsModal
};
export default connect(mapStateToProps, mapDispatchToProps);
